import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserService, AuthenticationService } from '@app/_services';
import { faPaperPlane, faArrowLeft, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-forget-username',
    templateUrl: './forget-username.component.html',
    styleUrls: ['./forget-username.component.css'],
    standalone: false
})
export class ForgetUsernameComponent implements OnInit {

  forgetUsernameForm! : FormGroup;
  loading = false;
  submitted = false;
  error = '';
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";

  faPaperPlane = faPaperPlane;
  faArrowLeft = faArrowLeft;
  faEnvelope = faEnvelope; 

  constructor(        private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private userService: UserService,
    private router: Router,
    private _location: Location,
    private authenticationService: AuthenticationService) { }


  ngOnInit(): void {
    this.forgetUsernameForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]]
    });
  }

  goBack() {
    this._location.back();
  }

  get f() { return this.forgetUsernameForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.loading = true;

    // stop here if form is invalid
    if (this.forgetUsernameForm.invalid) {

        this.loading = false;
        return;
    }

    var data = this.forgetUsernameForm.value;

    var request = { email: data.email};

    this.userService.requestUsernameDetails(request).subscribe(
      data => {
        this.toastr.success(data.message, 'Success');
        this.loading = false;
      }, 
      error => {
        this.toastr.error(error.message, 'Error');
        this.loading = false;
      }
    )

   
  }
}
